// Texty sticky lišty „Do košíka" na detaile produktu (stickyAtc.js).
export default {
  addToCart: 'Do košíka',
  /** aria-label regionu lišty */
  region: 'Rýchly nákup',
};
